import { useContext } from 'react';
import { JWTContext } from '../context/jwtContext';

const useAuth = () => {
    const context = useContext(JWTContext);

    if (!context) {
        throw new Error('useAuth must be used within a JWTProvider');
    }

    const { token, login, register, logout } = context;
    return { token, login, register, logout, isAuthenticated: !!token };
};

export default useAuth;
